import BubbleCommon, { shortGoogleText } from '@op/components/BubbleCommon';
import ChannelLabel from '@op/components/ChannelLabel';
import HoverSvgIcon from '@op/components/HoverSvgIcon';
import React from 'react';
import SvgIcon from '@home/components/SvgIcon';
import { AnalysisSummaryTypeTab } from '@op/pages/Summary/KeywordAndURLAnalysis/types';
/** ****************Sentiment Mentions******************/

export type MentionsSentimentTabType =
  | 'total'
  | 'game_store'
  | 'news'
  | 'social_media';

export const mentionsSentimentTab: (formatMessage: any) => {
  text: string | any;
  value: MentionsSentimentTabType;
}[] = (formatMessage) => [
  {
    text: (
      <div className="dbo-inlineflex">
        <SvgIcon type="studio-all"></SvgIcon>
        <span>{formatMessage({ id: 'Total-2' })}</span>
      </div>
    ),
    value: 'total',
  },
  {
    text: (
      <div className="dbo-inlineflex">
        <SvgIcon type="game-store"></SvgIcon>
        <span>{formatMessage({ id: 'Game Store' })}</span>
      </div>
    ),
    value: 'game_store',
  },
  {
    text: (
      <div className="dbo-inlineflex">
        <SvgIcon type="studio-streaming"></SvgIcon>
        <span>{formatMessage({ id: 'Social Media' })}</span>
      </div>
    ),
    value: 'social_media',
  },
  {
    text: (
      <div className="dbo-inlineflex">
        <SvgIcon type="new-media"></SvgIcon>
        <span>{formatMessage({ id: 'News Media' })}</span>
      </div>
    ),
    value: 'news',
  },
];

export type ByTypeSelectType =
  | 'by_mentions_type'
  | 'by_sentiment'
  | 'by_validation'
  | 'exclude_neutral'
  | 'exclude_low_invalid'
  | 'by_rating_ratio'
  | 'by_rating'
  | 'in_total';
export const sentimentMentionsOneLevelOptionsMap: {
  [key in MentionsSentimentTabType | AnalysisSummaryTypeTab]: Array<{
    text: string;
    value: ByTypeSelectType;
    pcFilter?: boolean;
  }>;
} = {
  total: [
    { text: 'By Mentions Type', value: 'by_mentions_type' },
    { text: 'By Sentiment', value: 'by_sentiment' },
    { text: 'By Validation', value: 'by_validation' },
    { text: 'Exclude Neutral', value: 'exclude_neutral' },
    { text: 'Exclude Low & Invalid', value: 'exclude_low_invalid' },
    { text: 'In Total', value: 'in_total' },
  ],
  game_store: [
    { text: 'By Rating', value: 'by_rating' },
    { text: 'By Rating%', value: 'by_rating_ratio' },
    { text: 'By Sentiment', value: 'by_sentiment', pcFilter: true },
  ],
  social_media: [
    { text: 'By Mentions Type', value: 'by_mentions_type' },
    { text: 'By Sentiment', value: 'by_sentiment' },
    { text: 'By Validation', value: 'by_validation' },
    { text: 'Exclude Neutral', value: 'exclude_neutral' },
    { text: 'Exclude Low & Invalid', value: 'exclude_low_invalid' },
    { text: 'In Total', value: 'in_total' },
  ],
  news: [{ text: 'By Sentiment', value: 'by_sentiment' }],
  'app store': [{ text: 'Filtered Reviews', value: 'by_rating' }],
  'google play': [{ text: 'Filtered Reviews', value: 'by_rating' }],
  steam: [{ text: 'Filtered Reviews', value: 'by_rating' }],
  community: [
    { text: 'By Mentions Type', value: 'by_mentions_type' },
    { text: 'By Sentiment', value: 'by_sentiment' },
    { text: 'By Validation', value: 'by_validation' },
    { text: 'Exclude Neutral', value: 'exclude_neutral' },
    { text: 'Exclude Low & Invalid', value: 'exclude_low_invalid' },
    { text: 'In Total', value: 'in_total' },
  ],
};

export const channelMentionSentimentTabType: {
  [key: string]: string;
} = {
  game_store: 'comments',
  social_media: 'social',
  news: 'news',
};

export const FILTER_HOUR_LIST = [
  'mentions_DAU',
  'mentions_revenue',
  'mentions_download',
  'mentions_PCU',
  'mentions_digital_rev',
  'mentions_units',
];

/** ****************Sentiment Mentions******************/

/** ****************Game Store******************/
export type GameStoreOneOptionsType = 'app store' | 'google play';
export const mobileGameStoreLabel = {
  'app store': 'APP Store',
  'google play': 'Google Play',
};
export const gameStoreOneOptions: (type: GameStoreOneOptionsType) => Array<{
  text: string | any;
  value: GameStoreOneOptionsType;
}> = (type) => [
  {
    text: (
      <div className="dbo-inlineflex">
        <ChannelLabel
          channel_name={'google play'}
          showText={false}
        ></ChannelLabel>
        <span>Google Play</span>
        <BubbleCommon
          placement="top"
          tipsMap={shortGoogleText}
          customIcon={
            <HoverSvgIcon selected={type === 'google play'}></HoverSvgIcon>
          }
        ></BubbleCommon>
      </div>
    ),
    value: 'google play',
  },
  {
    text: (
      <div className="dbo-inlineflex">
        <ChannelLabel
          channel_name={'app store'}
          showText={false}
        ></ChannelLabel>
        <span>App Store</span>
      </div>
    ),
    value: 'app store',
  },
];
export type GameStoreTwoOptionsType = 'lifetime' | 'selected';
export const gameStoreTwoOptions: Array<{
  text: string;
  value: GameStoreTwoOptionsType;
}> = [
    { text: 'Lifetime Rating', value: 'lifetime' },
    { text: 'Added Reviews', value: 'selected' },
  ];

/** ****************Game Store******************/

/** ****************AI Summary******************/
export function goToAISummary(history: any, e?: React.MouseEvent) {
  e?.stopPropagation();
  history.push('/opinion/AIAnalysisHub/CustomAISummary');
}
/** ****************AI Summary******************/
